import { TextField, Typography } from '@mui/material';
import { useState, useEffect } from 'react';
import { WizardButtons } from '../../Wizard/WizardButtons';
import { InsertClaimsFormRequest } from '../../../../../api/beneficiary';
import { useMutation } from '@tanstack/react-query';

export const Participant = (props) => {
  const [beneName, setBeneName] = useState('');
  const [emailAddress, setEmailAddress] = useState('');

  const claimsFormRequest = useMutation({
    mutationFn: async (data) => await InsertClaimsFormRequest(data)(),
  });

  useEffect(() => {
    if (claimsFormRequest.isSuccess) {
      successful();
    }
  }, [claimsFormRequest.isSuccess]);

  const successful = () => {
    localStorage.removeItem('participantInfo');
    localStorage.removeItem('policyCheckItems');
    props.nextHandler();
  };

  const handleParticipantSubmit = () => {
    const participantInfo = JSON.parse(localStorage.getItem('participantInfo'));
    const policyIdsArr = JSON.parse(localStorage.getItem('policyCheckItems'));
    const data = {
      insuredName: props.insuredFullName,
      beneficiaryName: beneName,
      beneficiaryEmail: emailAddress,
      insuredDateOfBirth: '2024-02-12T15:03:30.792Z',
      requestSetupID: 0,
      referenceID: props.referenceID,
    };
    policyIdsArr.map((policyID, idx) => (data[`policyID${decideID(idx)}`] = policyID));
    claimsFormRequest.mutate(data);
  };

  const decideID = (id) => {
    if (id > 0) return id + 1;
    else return '';
  };

  const renderText = () => {
    if (props.clickOnDocu) return 'Please provide recipient Name and Email';
    else return 'Please provide recipient Mailing Address';
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '10px',
      }}
    >
      <div style={{ marginBottom: '15px' }}>
        <Typography variant="h6">{renderText()}</Typography>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '10px',
        }}
      >
        <div>
          <TextField
            id=""
            label="Enter Beneficiary Name"
            variant="outlined"
            value={beneName}
            onChange={(e) => setBeneName(e.target.value)}
            required={true}
          />
        </div>
        <div>
          <TextField
            id="policyIDLookup"
            label="Email Address"
            variant="outlined"
            value={emailAddress}
            onChange={(e) => setEmailAddress(e.target.value)}
            required={true}
          />
        </div>
      </div>
      <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
        <WizardButtons
          {...props}
          nextHandler={handleParticipantSubmit}
          disabled={beneName === '' || emailAddress === ''}
          nextText="Submit"
        />
      </div>
    </div>
  );
};
